import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { TaxApiModelStub } from '../api-models/stubs/TaxApiModel.stub'
import { type TaxApiModel } from '../api-models/TaxApiModel'

export const mockGetTaxesSuccess = (
  taxStubs: TaxApiModel[] = [TaxApiModelStub.build()]
) => {
  return rest.get(`/api/v3/tax/`, (_, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(taxStubs)))
  })
}

export const mockGetTaxesError = () => {
  return rest.get(`/api/v3/tax/`, (_, res, ctx) => {
    return res.once(ctx.status(400))
  })
}
